import React, { useState, useEffect } from "react";
import {
    getSellerOffers,
    updateSellerOffers,
    getSellerId
} from "../../utils/api";


const OffersTable = ({ filters, refreshKey, setOfferEndTime }) => {

    const [offers, setOffers] = useState([]);
    const [changed, setChanged] = useState(false);
    const [loading, setLoading] = useState(true);

    const seller = getSellerId();
    useEffect(() => {

        loadOffers();
    }, [filters, refreshKey]);

    const loadOffers = async () => {

        try {

            setLoading(true);
            console.log(filters);

            const res = await getSellerOffers({
                seller_id: seller,
                page_number: 1,
                page_size: 10,
                area_id: filters.area?.id || "",
                grade_id: filters.grade?.id || ""
            });

            // setOffers(res.data || []);
            const formatted = (res.data || []).map(o => ({
                id: o.id,
                grade_name: o.grade_name,
                product: `${o.process_name} ${o.brand_name} ${o.code_name}`,
                qty: Number(o.qty),
                original_price: Number(o.original_price),
                is_availabe: Number(o.is_availabe),
                whatsapp: o.whatsappRequestCount || 0,
                calls: o.callRequestCount || 0
            }));

            // ✅ Check if ALL records have is_availabe === 0
            const allUnavailable = (res.data || []).every(
                o => Number(o.is_availabe) === 0
            );

            if (res.data?.length && allUnavailable) {
                setOfferEndTime(null); // 🔥 NO TIMER
            } else if (res.data?.length) {
                setOfferEndTime(res.data[0].offer_end_time);
            } else {
                setOfferEndTime(null);
            }
            setOffers(formatted);

        } catch (err) {

            console.error("Offer load error", err);

        } finally {

            setLoading(false);

        }

    };

    const handleUpdateOffers = async () => {

        try {

            const payload = offers.map(o => ({
                seller_id: seller,
                offer_id: o.id,
                qty: o.qty,
                original_price: o.original_price,
                price_validity: "24:00:00",
                is_availabe: o.is_availabe
            }));

            await updateSellerOffers(payload);
            loadOffers();
            setChanged(false);

        } catch (err) {

            console.error("Update error", err);

        }

    };
    const updateField = (id, field, value) => {

        const updated = offers.map(o =>
            o.id === id ? { ...o, [field]: value } : o
        );

        setOffers(updated);
        setChanged(true);
    };

    return (
        <div className="card offers-table">

            <h3>My Offers ({offers.length})</h3>

            <div className="table-scroll">

                <table>

                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Grade</th>
                            <th>Product</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Whatsapp</th>
                            <th>Calls</th>
                            <th>Available</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading && (
                            <tr>
                                <td colSpan="8">Loading offers...</td>
                            </tr>
                        )}
                        {offers.map((o, i) => (
                            <tr key={o.id}>
                                <td>{i + 1}</td>
                                <td>{o.grade_name}</td>
                                <td>{o.product}</td>
                                <td>
                                    <div className="number-input">

                                        <button
                                            type="button"
                                            onClick={() =>
                                                updateField(
                                                    o.id,
                                                    "original_price",
                                                    Number((Number(o.original_price) - 0.05).toFixed(2))
                                                )
                                            }
                                        >
                                            -
                                        </button>

                                        <input
                                            type="number"
                                            step="0.05"
                                            value={o.original_price}
                                            onChange={(e) =>
                                                updateField(o.id, "original_price", Number(e.target.value))
                                            }
                                        />

                                        <button
                                            type="button"
                                            onClick={() =>
                                                updateField(
                                                    o.id,
                                                    "original_price",
                                                    Number((Number(o.original_price) + 0.05).toFixed(2))
                                                )
                                            }
                                        >
                                            +
                                        </button>

                                    </div>
                                </td>

                                <td>
                                    <div className="number-input">

                                        <button
                                            type="button"
                                            onClick={() =>
                                                updateField(o.id, "qty", Math.max(0, Number(o.qty) - 1))
                                            }
                                        >
                                            -
                                        </button>

                                        <input
                                            type="number"
                                            value={o.qty}
                                            onChange={(e) =>
                                                updateField(o.id, "qty", Number(e.target.value))
                                            }
                                        />

                                        <button
                                            type="button"
                                            onClick={() =>
                                                updateField(o.id, "qty", Number(o.qty) + 1)
                                            }
                                        >
                                            +
                                        </button>

                                    </div>
                                </td>

                                <td>{o.whatsapp}</td>
                                <td>{o.calls}</td>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={o.is_availabe === 1}
                                        onChange={(e) =>
                                            updateField(o.id, "is_availabe", e.target.checked ? 1 : 0)
                                        }
                                    />
                                </td>

                            </tr>
                        ))}
                    </tbody>

                </table>

            </div>

            {changed && (
                <div className="update-offer-wrapper">
                    <button
                        className="btn-primary update-btn"
                        onClick={handleUpdateOffers}
                    >
                        Save Updated Offers
                    </button>
                </div>
            )}
        </div>
    );
};

export default OffersTable;